var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropdownLightGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 10,
    viewBox: "0 0 18 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3897 0L1.6174 0C0.183666 0 -0.541257 1.63823 0.473637 2.59386L7.86786 9.55631C8.49613 10.1479 9.51102 10.1479 10.1393 9.55631L17.5335 2.59386C18.5323 1.63823 17.8235 0 16.3897 0Z",
    fill: "#B9C1C8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownLightGrey);
export default __webpack_public_path__ + "static/media/dropdown-light-grey.32951a5ea6bfbe7da1297d26ff4eaeea.svg";
export { ForwardRef as ReactComponent };